export var AppLinkDomains = [
    'www.office.com',
    'www.officeppe.com',
    'www.office365.us',
    'scuprodprv.www.office.com',
    'neuprodprv.www.office.com',
    'ohome.microsoft.scloud',
    'ohome.eaglex.ic.gov',
    'www.ohome.apps.mil',
    'localhost:5000',
];
//# sourceMappingURL=AppLinkDomains.js.map